// Dead-simple multi-file download. ONE approach:
//   For each file → create an anchor → click → file downloads → wait → next file.
//
// We use the /api/files/<key>?name=... endpoint which streams the file with a
// Content-Disposition: attachment header. The browser sees that header and saves
// the file (instead of navigating). The `download` attribute on the anchor is
// a friendly hint for the filename.
//
// Between each click we wait 1500ms. That's the magic number that keeps Chrome
// from showing its "this site wants to download multiple files" prompt — at
// that pace the browser treats each download as a separate user action.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

function sanitizeName(name) {
    return String(name).replace(/[<>:"/\\|?*\x00-\x1f]/g, "_").trim() || "bestand";
}

function streamingUrl(urlOrPath, friendlyName) {
    // Convert /api/uploads/<key> (or <key>?dl=...) → /api/files/<key>?name=...
    // The /api/files/ endpoint streams with Content-Disposition: attachment so
    // even cross-origin clicks always save instead of navigating.
    const path = urlOrPath || "";
    const m = path.match(/\/api\/uploads\/([^?]+)/);
    const key = m ? m[1] : path.split("/").pop().split("?")[0];
    return `${BACKEND}/api/files/${encodeURIComponent(key)}?name=${encodeURIComponent(friendlyName)}`;
}

export async function downloadProjectAssets({ folderName, files, onProgress }) {
    if (!files || files.length === 0) throw new Error("Geen bestanden om te downloaden");
    const prefix = sanitizeName(folderName || "project");
    let done = 0;
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const baseName = sanitizeName(file.filename || `bestand-${i + 1}`);
        const finalName = baseName.startsWith(prefix) ? baseName : `${prefix} - ${baseName}`;
        onProgress && onProgress({ done, total: files.length, currentFile: finalName });

        const a = document.createElement("a");
        a.href = streamingUrl(file.url, finalName);
        a.download = finalName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();

        // Wait 1500ms between downloads — long enough that Chrome doesn't flag
        // it as a multi-download burst (which would silently block the rest).
        // For the FIRST → SECOND transition we wait 2500ms because that's when
        // Chrome typically shows its permission prompt — gives the user time to
        // click "Toestaan" before we trigger the next.
        const isFirst = i === 0;
        await sleep(isFirst ? 2500 : 1500);

        done += 1;
        onProgress && onProgress({ done, total: files.length, currentFile: finalName });
    }
    return { method: "anchors" };
}

export function supportsFolderDownload() {
    return false;
}
